import React, { useEffect, useState } from "react";

export const EstadoSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-estado"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="A">Activa</option>
      <option value="P">Por Vencer</option>
      <option value="V">Vencida</option>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};